module.exports = __webpack_public_path__ + "media/images/icon/icons8-Save-85e9f5a2ed074960f42d600eb8269a01.png";